export const FLAG_GETTING_CHASSIS_BODYWORKS = 'FLAG_GETTING_CHASSIS_BODYWORKS';
export const GET_CHASSIS_BODYWORKS = 'GET_CHASSIS_BODYWORKS';
export const CLEAR_CHASSIS_BODYWORKS = 'CLEAR_CHASSIS_BODYWORKS';
